import React from "react";
import styled from "styled-components";
import MagicLinksIcon from "../../components/InbioContentComponents/icons/MagicLinksIcon";
import MagicLinksLogo from "../../components/InbioContentComponents/icons/MagicLinksLogo";
import LeftBackgroundImage from "../../assets/images/left-bg-image.png";
import RightBackgroundImage from "../../assets/images/right-bg-image.png";

const PageContainer = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100vw;
  height: 100vh;
  margin: -8px;
`;

const MessageContainer = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 88px;
`;

const Message = styled("div")`
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 130%;
  color: #111111;
  margin-left: 24px;
  margin-right: 24px;
  text-align: center;
  @media (max-width: 560px) {
    font-size: 16px;
  }
`;

const Description = styled("div")`
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  color: #5a6781;
  margin-top: 16px;
  margin-left: 24px;
  margin-right: 24px;
  text-align: center;
  @media (max-width: 560px) {
    font-size: 12px;
  }
`;

const IconContainer = styled("div")`
  margin-top: 74px;
  cursor: pointer;
`;

const LogoContainer = styled("div")`
  display: flex;
  align-items: flex-end;
  flex: 1;
  margin-bottom: 32px;
`;

const LeftBackgroundImageContainer = styled("div")`
  position: absolute;
  left: 0;
  bottom: -4px;

  @media (max-width: 1024px) {
    display: none;
  }
`;

const RightBackgroundImageContainer = styled("div")`
  position: absolute;
  right: 0;
  bottom: -4px;

  @media (max-width: 1024px) {
    display: none;
  }
`;

export default function Page() {
  return (
    <PageContainer>
      <IconContainer
        onClick={() => window.open("https://magiclinks.com", "_blank")}
      >
        <MagicLinksIcon />
      </IconContainer>
      <MessageContainer>
        <Message>Sorry, the page you’re looking for is not available.</Message>
        <Description>
          The link you followed may be broken, or the page may have been
          removed.
        </Description>
      </MessageContainer>
      <LogoContainer>
        <MagicLinksLogo />
      </LogoContainer>
      <LeftBackgroundImageContainer>
        <img src={LeftBackgroundImage} width={350} />
      </LeftBackgroundImageContainer>
      <RightBackgroundImageContainer>
        <img src={RightBackgroundImage} width={350} />
      </RightBackgroundImageContainer>
    </PageContainer>
  );
}
